import { type z } from 'zod';
import { EditUserValidatorSchema } from 'data/validators/body/user/edit-user.validator';

export const UserEditValidatorSchema = EditUserValidatorSchema.extend({});

export type UserEditValidator = z.infer<typeof UserEditValidatorSchema>;
